<template>
  <div class="content">
    <PageHeader title="SMS Dashboard" />
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-lg-6 col-xl-6">
          <div class="card">
            <div class="card-header">
              <span class="m-t-5 d-inline-block">{{$t('sms.dashboard.messages.title')}}</span><!-- Mensagens -->
              <ul
                class="nav nav-pills nav-pills-primary float-right"
                id="pills-demo-sales"
                role="tablist"
              >
                <li class="nav-item">
                  <select v-model="messageDays" class="form-control">
                    <option value="7">{{$t('sms.dashboard.messages.days.7')}}</option><!-- 7 Dias -->
                    <option value="30">{{$t('sms.dashboard.messages.days.30')}}</option><!-- 30 Dias -->
                  </select>
                </li>
              </ul>
            </div>
            <div class="card-body block-el">
              <messages-chart :days="messageDays" />
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-6">
          <div class="card">
            <div class="card-header">
              <span class="m-t-5 d-inline-block">{{$t('sms.dashboard.carriers.title')}}</span><!-- Operadoras -->
              <ul
                class="nav nav-pills nav-pills-primary float-right"
                id="pills-demo-sales"
                role="tablist"
              >
                <li class="nav-item">
                  <select v-model="carrierDays" class="form-control">
                    <option value="7">{{$t('sms.dashboard.carriers.days.7')}}</option><!-- 7 Dias -->
                    <option value="30">{{$t('sms.dashboard.carriers.days.30')}}</option><!-- 30 Dias -->
                  </select>
                </li>
              </ul>
            </div>
            <div class="card-body block-el">
              <carriers-chart :days="carrierDays" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <sms-recent-card />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/PageHeader.vue';
import MessagesChart from '@/components/sms/MessagesChart.vue';
import CarriersChart from '@/components/sms/CarriersChart.vue';
import SmsRecentCard from '@/components/sms/RecentCard.vue';

export default {
  name: 'SmsDashboard',
  components: {
    PageHeader,
    MessagesChart,
    CarriersChart,
    SmsRecentCard,
  },
  data() {
    return {
      messageDays: 7,
      carrierDays: 7,
    };
  },
};
</script>
